import { TextField, TextFieldProps } from '@mui/material';
import * as R from 'ramda';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

interface RHFTextFieldProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  textFieldProps?: TextFieldProps;
  testId?: string;
}

const RHFTextField = <T extends FieldValues>({
  name,
  control,
  textFieldProps,
  testId,
}: RHFTextFieldProps<T>) => {
  const isNumberType = textFieldProps?.type === 'number';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState, formState, ...rest }) => {
        const value = R.isNil(field.value) ? '' : String(field.value);
        return (
          <TextField
            {...rest}
            {...field}
            value={value}
            {...textFieldProps}
            {...(isNumberType && {
              onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                const rawValue = event.target.value;
                field.onChange(rawValue === '' ? null : Number(rawValue));
                textFieldProps?.onChange?.(event);
              },
            })}
            InputLabelProps={{
              shrink: value !== '' || undefined,
              ...textFieldProps?.InputLabelProps,
            }}
            inputProps={{ ...textFieldProps?.inputProps, 'test-id': testId }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message || textFieldProps?.helperText}
          />
        );
      }}
    />
  );
};

export default RHFTextField;
